<template>
  <header class="site-header site-width">
    <div class="row justify-between">
      <div class="col-6">
        <q-btn
          @click.native="$emit('sidebar')"
          :icon="isMenuOpen ? 'close' : 'menu'"
          round
          circle
          color="white"
          text-color="primary"
          class="btn-menu no-shadow btn-sidebar-opener"
        />
      </div>
      <div class="col-6 text-right">
        <q-btn
          :to="{ path: '/' }"
          icon="home"
          round
          circle
          color="white"
          text-color="secondary"
          class="btn-home no-shadow"
        />
      </div>
    </div>
    <slot />
  </header>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

// @group Layout
// Site Header
export default {
  name: 'site-header',
  props: {
    isMenuOpen: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['user', 'isLoggedIn']),
  },
  methods: {
    ...mapActions(['userLogout']),
  },
};
</script>
<style lang="stylus">
@import '~quasar-variables';
.site-header {
  height: 0;
  position: fixed;
  z-index: 1000;
  .btn-menu {
    position: absolute;
    top: 5px;
    left: 5px;
    z-index: 10000;
    & > * {
      pointer-events: none;
    }
  }
  .btn-home {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 10000;
  }
}
</style>
